import { Injectable } from '@angular/core';
import { Observable,Subject } from 'rxjs';

import * as CryptoJS from 'crypto-js';
import { environment } from '../environments/environment';

 
@Injectable()
export class EncryptionService {



    EncriptObject(CipherText:string):string
    {
      var param = environment;               
      if (!param.St.StatusDesc) {
          throw new Error("Encryption key is not initialized.");
      }

      var EncriptCipherText = CryptoJS.AES.encrypt(JSON.stringify(CipherText), param.St.StatusDesc).toString();
      return EncriptCipherText;
    }

    DecriptObject(CipherText:string):string
    {
      var param = environment;           
      if (!param.St.StatusDesc) {
          throw new Error("Encryption key is not initialized.");
      }
      
      var CipherTextbytes  = CryptoJS.AES.decrypt(CipherText, param.St.StatusDesc);
      var DeCriptCipherText = JSON.parse(CipherTextbytes.toString(CryptoJS.enc.Utf8));      
      return DeCriptCipherText;

    }

    EncriptPayload(CipherText:string):string
    {
      var param = environment;              
      if (!param.St.StatusDesc) {
          throw new Error("Encryption key is not initialized.");
      }
      
      var passKey = param.St.StatusDesc;
      var key = CryptoJS.enc.Utf8.parse(passKey);
      var iv = CryptoJS.enc.Utf8.parse(passKey);
      var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(CipherText), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    }

    DecriptPayload(CipherText:string):string
    {
      var param = environment;               
      if (!param.St.StatusDesc) {
          throw new Error("Encryption key is not initialized.");
      }

      var passKey = param.St.StatusDesc;
      var key = CryptoJS.enc.Utf8.parse(passKey);
      var iv = CryptoJS.enc.Utf8.parse(passKey);
      var DecryptBytes = CryptoJS.AES.decrypt(CipherText, key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      var DeCriptCipherText = JSON.parse(DecryptBytes.toString(CryptoJS.enc.Utf8));      
      return DeCriptCipherText;
    }


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/EncryptionService.ts